const GLOBAL_NAMESPACE = 'tiweb.';
export const USER = GLOBAL_NAMESPACE + 'user';
export const NEWS = GLOBAL_NAMESPACE + 'news';

class LocalStorage {
  get(key) {
    return localStorage.getItem(key);
  }

  set(key, value) {
    if (!value && value === undefined) return;
    localStorage.setItem(key, value);
  }

  getJson(key) {
    const json = localStorage.getItem(key);
    return json ? JSON.parse(json) : null;
  }

  setJson(key, value) {
    if (!value && value === undefined) return;
    localStorage.setItem(key, JSON.stringify(value));
  }

  remove(key) {
    localStorage.removeItem(key);
  }

  clear() {
    localStorage.clear();
  }
}

export const TiLocalStorage = new LocalStorage();

class SessionStorage {
  get(key) {
    return sessionStorage.getItem(key);
  }

  set(key, value) {
    if (!value && value === undefined) return;
    sessionStorage.setItem(key, value);
  }

  getJson(key) {
    const json = sessionStorage.getItem(key);
    return json ? JSON.parse(json) : null;
  }

  setJson(key, value) {
    if (!value && value === undefined) return;
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  remove(key) {
    sessionStorage.removeItem(key);
  }

  clear() {
    sessionStorage.clear();
  }
}

export const TiSessionStorage = new SessionStorage();
